import Api from '@ambuliz/sabri-core';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

Api.serverURL = import.meta.env.https://brancardage.parse.stage.ambuliz.com;
Api.initialize(import.meta.env.cvWM2V5taMwk23IvvHeKFB80BZWLiqMZ);
Api.enableLocalDatastore();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
